<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'protype',
})
</script>
<template>
<a-card title="产品分类">
  <template  #extra>
        <a-button type="primary" v-if="auth.creating>0" @click="add(0)"><PlusOutlined /> 新增 </a-button>
    </template>
  <lanseed-form v-model:open="formshow" :data="formModel" :rules="formRole"  @change="submit"></lanseed-form>
  <a-table rowKey="ID"  :row-selection="rowselection"  :columns="columns" :dataSource="dataSource" :pagination="false" :loading="loading" @change="pageChange">
    <template #title>
      <div v-if="rowselection.selectedRowKeys.length>0&&auth.del>0"  class="padding flex align-center" style="width: 100%;">
        <span class="text-gray">共选择了<span class="text-primary text-bold padding-lr-sm">{{ rowselection.selectedRowKeys.length }}</span>条数据</span>
        <a-button type="primary" danger size="small" class="margin-left" @click="onDel">
        <DeleteOutlined  />  删除</a-button>
      </div>
    </template>
    <template #bodyCell="{column,record,index}">
      <a-button-group v-if="column.key=='action'">
            <a-button  v-if="auth.edit>0" size="small" type="primary" @click="edit(record,index)">
                <EditOutlined /> 编辑
            </a-button>
          </a-button-group>
    </template>
  </a-table>
</a-card>
</template>
<script setup lang="ts" name="protype">
import api from '@/utils/http/service'
import { onMounted,ref,getCurrentInstance } from 'vue'
import {DeleteOutlined,PlusOutlined,EditOutlined} from   '@ant-design/icons-vue'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import LanseedForm from '@/components/lanseed/form.vue'
import {message} from 'ant-design-vue'
const auth:any=api.auth()
const dataSource=ref<Array<any>>([])
const selectedIDS=ref<Array<any>>([])
const loading=ref<Boolean>(false)
const page=ref<Record<string,string>>({
  current:1,
  pageSize:10,
  total:0
})
const columns:Array<any>=[
  {title:'名称',dataIndex:'title'},
  {title:'操作',key:'action',},
]
const searchVal:Record=ref({
  keyword:''
})
const searchRule:Record=ref()
const rowselection:any=ref({
  fixed:true,
  selectedRowKeys:[],
  onChange:(e:any)=>{
    rowselection.value.selectedRowKeys=e
  }
})
const formModel:Record=ref({})
const formRole=ref({
  title:{name:'标题',required:true},
  pic:{domtype:'img',name:'图标',max:1},
  orders:{domtype:'number',name:'排序'},
})
const formshow=ref<Boolean>(false)
const getDataList=():void=>{
  loading.value = true
  api.protype.list({ pageIndex: page.value.current, pageSize: page.value.pageSize,...searchVal.value }).then(res => {
        loading.value = false
        if (res.state == 1) {
          page.value.current=res.data.pageIndex
          page.value.total=res.data.records
          dataSource.value = res.data.data
        }
      })
}
const search=(e):void=>{
  searchVal.value=e
  page.value.current=1
  getDataList()
}
const pageChange=(e):void=>{
  page.value.current=e.current
  page.value.pageSize=e.pageSize
  getDataList()
}
const onDel=(item:any,index:number):void=>{
  api.protype.dels(rowselection.value.selectedRowKeys).then(res => {
          if (res.state == 1) {
            message.success(res.message)
            getDataList()
          }
        })
}
const add=(pid):void=>{
  formModel.value={
    ID:0,title:'',pic:[],pid:pid,orders:0
  }
  formshow.value=true
}
const edit=(item,index):void=>{
  formModel.value=item
  formshow.value=true
}
const submit=(e):void=>{
  api.protype.add(e).then(res=>{
    if(res.state==1){
      if(e.ID==0){
        dataSource.value.unshift(res.data)
      }else{
        let index =dataSource.value.findIndex(f=>{return f.ID==e.ID})
        dataSource.value[index]=res.data
      }
      formshow.value=false
      formModel.value=null
    }
  })
}
onMounted(()=>{
  getDataList()
})
</script>
